import { useState } from 'react'
import { type Control, type FieldError, useWatch } from 'react-hook-form'
import { Show } from '@/components/show'
import { AdaptationModal } from '@/components/tables/courses-quivalences/components/adaptation-modal'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import type { SelectWithAddOption } from '@/types/select/select-with-add-option'
import { SelectWithAddNew } from '../select-with-add-new'

interface EquivalencesSelect {
  selectedValue: SelectWithAddOption
  options: SelectWithAddOption[]
  onChange: (value: SelectWithAddOption) => void
  canCreateNew?: boolean
  canSelect?: boolean
  formControl?: Control<MatchCoursesFormType>
  error?: FieldError
  courseType: 'desiredCourse' | 'previousCourse'
  elementPlaceholder?: React.ReactNode
  showAdaptationModal?: boolean
}

export const EquivalencesSelect = ({
  formControl,
  courseType,
  options,
  ...props
}: EquivalencesSelect) => {
  const [openModal, setOpenModal] = useState(false)

  const manualSelected =
    useWatch({
      control: formControl,
      name: 'courseEquivalences'
    }) ?? []
  const automaticSelected =
    useWatch({
      control: formControl,
      name: 'automaticCourseEquivalences'
    }) ?? []

  const allSelected = [...manualSelected, ...automaticSelected].filter(Boolean)

  const availableOptions = options.filter(
    (option) =>
      !allSelected.some((selected) => {
        const selectedId = selected?.[courseType]?.id
        const desiredCourseId = selected?.desiredCourse?.courseId

        return (
          (selectedId != null && selectedId === option.id)
          || (desiredCourseId != null && desiredCourseId === option.id)
        )
      })
  )

  function handleOpenModal() {
    setOpenModal(true)
  }

  return (
    <>
      <Show
        when={!props.showAdaptationModal}
        fallback={
          <div className="w-full h-11 border-b border-ring">
            <button
              type={'button'}
              className="font-bold h-full w-full flex ps-2 cursor-pointer items-center underline text-[var(--brand-blue-3)] uppercase"
              onClick={handleOpenModal}
            >
              Entenda como funciona
            </button>
          </div>
        }
      >
        <SelectWithAddNew options={availableOptions} {...props} />
      </Show>

      <AdaptationModal isOpen={openModal} setOpen={setOpenModal} />
    </>
  )
}
